import { useQuery } from "react-query";
import { Totals } from "@ecologi/shared";
import { getTotals, APIError } from "../api";

export function useTotals() {
  return useQuery<Totals, APIError>("totals", getTotals);
}

useTotals.queryKey = "totals";
